// ===============================
// BackToTop Button（GSAPなしで軽量化）
// ===============================

export const initBackToTop = () => {
    const btn = document.getElementById("backtotop");
    const sentinel = document.getElementById("backtotop-sentinel");
    if (!btn || !sentinel) return;

    const REDUCE_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // 可視判定（IO と 距離 の OR）
    const updateVisible = (intersecting = false) => {
        const scrolled = window.scrollY > 200;            // ← 距離の保険
        const visible = intersecting || scrolled;
        btn.hidden = !visible;
        btn.classList.toggle("is-visible", visible);
    };

    // 表示制御（IO）
    const io = new IntersectionObserver(
        ([entry]) => {
            // console.log("IO:", entry.isIntersecting); // デバッグ用
            updateVisible(entry.isIntersecting);
        },
        { rootMargin: "0px 0px -10% 0px", threshold: 0 }  // ← 少し緩める
    );
    io.observe(sentinel);

    // 距離ベースの保険（軽量）
    window.addEventListener("scroll", () => updateVisible(false), { passive: true });

    // 初期評価（リロード直後の位置でも反映）
    updateVisible(false);

    // スクロール動作
    btn.addEventListener(
        "click",
        () => {
            if (REDUCE_MOTION) {
                window.scrollTo({ top: 0 });
                return;
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        { passive: true }
    );
};
